export default {
    _prefix: "AgreementRate",
    label: "Agreement Score",
    percentage: (data: { percentage: number }) => "{{percentage}}%",
    tooltip: {
        formAgreementRateInfo:
            "Agreement score shows how often users accepted AI-suggested answers across the entire form. A higher score means the form's questions are well-structured for AI.",
    },
    ariaLabels: {
        agreementRateInfo: "Agreement rate information",
        goodAgreementRate: "Good agreement rate",
        moderateAgreementRate: "Moderate agreement rate",
        lowAgreementRate: "Low agreement rate",
        agreementRatePercentage: (data: { percentage: number }) =>
            "{{percentage}} percent agreement rate",
    },
};
